import { EventBus, Events } from "jiffy-store";
import MastheadCartDropdownItems from "./masthead-cart-dropdown-items-class";

// Constants
const SELECTORS = {
  SAVED_CARTS_COUNT: ".js-saved-carts-count"
};

export default class MastheadCartDropdownEvents {
  constructor({
    countSelector = SELECTORS.SAVED_CARTS_COUNT,
    cartItems = null,
    loader = null
  } = {}) {
    this.countSelector = countSelector;
    this.cartItems = cartItems;
    this.loader = loader;
    this.listenersInitialized = false;
  }

  // Getters
  $getSavedCartsCount = () => document.querySelector(this.countSelector);

  // Setters
  setSavedCartsCount(count) {
    const $savedCartsCount = this.$getSavedCartsCount();
    if ($savedCartsCount) {
      $savedCartsCount.textContent = count;
    }
  }

  // EventBus handlers
  onSavedCartsLoaded = (_, data) => {
    if (this.cartItems) {
      this.cartItems.renderSavedCartsFromData(data.carts, data.activeCart);
    }
    this.setSavedCartsCount(data.carts ? data.carts.length : 0);
  };

  static onCartQuantityUpdated(_, { quantity }) {
    MastheadCartDropdownItems.updateActiveCartBadge(quantity);
  }

  // Actions
  renderSavedCarts() {
    // Show initial loading state
    if (this.loader) {
      this.loader.show("Loading saved carts...");
    }

    // Only add listeners if they haven't been initialized yet to prevent duplicates
    if (!this.listenersInitialized) {
      EventBus.on(Events.SAVED_CARTS_LOADED, this.onSavedCartsLoaded);
      EventBus.on(Events.CART_QUANTITY_UPDATED, MastheadCartDropdownEvents.onCartQuantityUpdated);
      this.listenersInitialized = true;
    }
  }

  // Inits
  init() {
    this.renderSavedCarts();
  }
}
